import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/index.css';
import { GalleryPage } from './routes/GalleryPage';
import { AdminLoginPage } from './routes/AdminLoginPage';
import { AdminDashboardPage } from './routes/AdminDashboardPage';
import { AppLayout } from './components/AppLayout';
import { RequireAuth } from './components/RequireAuth';

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found in index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<GalleryPage />} />
          <Route path="admin" element={<AdminLoginPage />} />
          <Route
            path="admin/dashboard"
            element={
              <RequireAuth>
                <AdminDashboardPage />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
